import React from 'react';

export const ResponsiveContext = React.createContext();
export const DemoContext = React.createContext();

export default {
  ResponsiveContext,
  DemoContext,
};
